/**
 * 接口axios实例
 * Author: Huangzhh
 */

import Axios, { AxiosInstance } from 'axios'
import { isAxiosSuccess } from '../api/interface'
import networdError from '../api/networdError'
import { BaseAuthConfig, generateAuth } from './authUtils'

declare module 'axios' {
  interface AxiosRequestConfig {
    needAuth?: boolean
    authOptions?: BaseAuthConfig
  }
}

/**
  *
  */
const server: AxiosInstance = Axios.create({
  timeout: 30000
})

const whiteList = ['https://api.weelife3d.com/v1/common/index']

// 游戏服务端 请求拦截
server.interceptors.request.use(
  (config) => {
    if (config.needAuth) {
      if (config.params) {
        config.params = generateAuth(config.params, config.authOptions)
      }
      if (config.data) {
        config.data = generateAuth(config.data, config.authOptions)
      }
      if (!config.params && !config.data) {
        config.params = generateAuth({}, config.authOptions)
      }
      return config
    }
    return config
  },
  async (error: Error) => {
    return Promise.reject(error)
  }
)

// 游戏服务端 响应拦截
server.interceptors.response.use((response) => {
  const res = response.data
  const isWhiteList = response?.config?.url && whiteList.includes(response.config.url)
  if (res.status !== 1 && res.code !== 1 && !isWhiteList) {
    // 主动上报失败接口
    // const sentryMsg = {
    //   request: response.config,
    //   response: response.data
    // };
    // sentryManager.captureMessage(JSON.stringify(sentryMsg), Severity.Error);

    return networdError(res)
  }
  if (isAxiosSuccess(res) || isWhiteList) {
    return response.data
  } else {
    return Promise.reject(res)
  }
}, async err => {
  if (err.message === 'Network Error') {
    // Toast.fail('网络无法连接，请检查网络后重试')
  }
  return Promise.reject(err)
})

export default server
